import { Button } from "@aircall/ds";
import { AiAssist } from "@aircall/react-icons";
import { FeatureBanner } from "@/components/FeatureBanner/FeatureBanner";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

export function PlaygroundFeatureBanner() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic Usage</PlaygroundSubSectionTitle>
        <p className="text-xs font-normal text-muted-foreground">
          A promotional banner with a leading icon, a headline and trailing
          actions on the right. Uses the brand mint gradient background.
        </p>
        <FeatureBanner content="Discover our new AI features" icon={AiAssist}>
          <Button variant="link" size="sm">
            Learn more
          </Button>
        </FeatureBanner>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Fluid width</PlaygroundSubSectionTitle>
        <p className="text-xs font-normal text-muted-foreground">
          With <code>fluid</code> the banner stretches to fill its container.
        </p>
        <FeatureBanner
          fluid
          content="This banner takes the full available width"
          icon={AiAssist}
        >
          <div className="flex items-center gap-4">
            <Button variant="link" size="sm">
              Dismiss
            </Button>
            <Button variant="secondary" size="sm">
              Upgrade
            </Button>
          </div>
        </FeatureBanner>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Vertical layout</PlaygroundSubSectionTitle>
        <p className="text-xs font-normal text-muted-foreground">
          With <code>direction="vertical"</code> and a capped <code>maxW</code>,
          content stacks and left-aligns.
        </p>
        <FeatureBanner
          direction="vertical"
          alignItems="flex-start"
          maxW={320}
          content="Stacked feature callout"
          icon={AiAssist}
        >
          <Button variant="link" size="sm">
            Get started
          </Button>
        </FeatureBanner>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
